import type { ApiDashboardStats, DashboardStatistics } from '../types';

export const toDashboardStatistics = (api: ApiDashboardStats): DashboardStatistics => ({
  resources: {
    locations: api.resources.locations,
    groups: api.resources.groups,
    children: api.resources.children,
  },
  observations: {
    dueWithinWeek: api.questionnaires.expiring.inWeek,
    dueWithinMonth: api.questionnaires.expiring.inMonth,
    deadlineBeyond: api.questionnaires.expiring.later,
    upcoming: api.questionnaires.upcoming.inMonth,
    completed: api.questionnaires.history.completedLast90Days,
    expired: api.questionnaires.history.expiredLast90Days,
  },
});
